"use client";

import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specifications = [{
  label: "Weight",
  value: "16.416 kg"
}, {
  label: "Sizes",
  value: "226.3*226.3*454mm³(16U)"
}, {
  label: "Orbit",
  value: "Sun-Synchronous"
}, {
  label: "Spatial Resolution",
  value: "2.5m (RGB) and 3.0m (NIR)"
}, {
  label: "Spectral Bands",
  value: "Multispectral RGB"
}, {
  label: "Sensor Tilt Angle",
  value: "30°"
}];
export default function TechnicalSpecifications() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return;
}